export default (arr: any[]): any[] => arr.filter(Boolean);
